"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    DarkLayer: {
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme['$z-index-overlay']
    },
    Overlay: function Overlay(_ref) {
      var props = _ref.props;
      return {
        width: props.width,
        height: props.height,
        background: theme['$overlay-background'],
        borderRadius: 6,
        color: theme['$text-color'],
        display: 'block',
        fontFamily: theme['$font-default'],
        fontSize: 12,
        minWidth: 240,
        minHeight: 124
      };
    },
    OverlayHeader: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'row'
    },
    OverlayClose: {
      flexGrow: 1,
      justifyContent: 'flex-end',
      paddingRight: 10,
      paddingTop: 10,
      textAlign: 'right'
    },
    OverlayTitle: {
      fontFamily: theme['$font-heading'],
      textOverflow: 'ellipsis',
      maxWidth: '80%',
      overflow: 'hidden',
      fontSize: 14,
      fontWeight: 700,
      flexGrow: 3,
      justifyContent: 'flex-start',
      paddingLeft: 20,
      paddingTop: 20
    },
    OverlayContent: function OverlayContent(_ref2) {
      var props = _ref2.props;
      return {
        padding: props.contentPadding
      };
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map